module.exports = "<div class=\"igo-geolocate-button-container\">\r\n  <button\r\n    mat-icon-button\r\n    [matTooltip]=\"'igo.mapButtons.geolocate' | translate\"\r\n    matTooltipPosition=\"left\"\r\n    [color]=\"color\"\r\n    (click)=\"map.geolocate()\">\r\n    <mat-icon>\r\n      my_location\r\n    </mat-icon>\r\n  </button>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/lib/map/geolocate-button/geolocate-button.component.html
// module id = 896
// module chunks = 0